/**
 * Static map from kebab-case icon names to Lucide React components.
 * Explicit named imports for tree-shaking.
 */
import {
  // People
  User, Users, UserCheck, UserPlus, Contact,
  Baby, Brain, Heart, Fingerprint, HandHeart,
  CircleUserRound, UserCircle,
  // Places
  Building, Building2, Home, MapPin, Globe,
  Landmark, Mountain, Map, Compass, Flag,
  // Business
  Briefcase, Calculator, Presentation, Handshake,
  IdCard, Receipt, Wallet, Scale, Gavel, Stamp,
  // Education
  GraduationCap, BookOpen, Library, School,
  Notebook, Pencil, Ruler, Atom, FlaskConical, Microscope,
  // Health
  HeartPulse, Stethoscope, Pill, Syringe,
  Activity, Dumbbell, Apple, Bed, Thermometer, Eye,
  Gauge,
  // Tech
  Laptop, Smartphone, Server, Database, Cpu,
  Wifi, Code, Terminal, Cloud, HardDrive,
  Monitor, Keyboard, Mouse, Printer, Cable,
  GitBranch, GitCommitHorizontal, GitPullRequest,
  FolderGit2, FolderTree, Layers,
  // Media
  Image, Camera, Video, Music, Mic,
  Film, Headphones, Tv, Radio, Newspaper,
  PlayCircle, StickyNote, FileText,
  // Comms
  Mail, MessageCircle, Phone, Megaphone,
  AtSign, Send, Rss, Bell, Inbox, MessageSquare,
  MessagesSquare, Link2,
  // Finance
  CreditCard, Banknote, Coins, PiggyBank,
  ShoppingCart, Store, TrendingUp, BarChart3,
  PieChart, BadgeDollarSign,
  ArrowLeftRight, BarChart2, MinusCircle,
  // Travel
  Car, Plane, TrainFront, Ship, Bike,
  Fuel, Navigation, Luggage, Ticket, Route,
  // Nature
  Leaf, Flower, Sun, Moon, CloudSun,
  Droplets, Wind, Snowflake, Sprout, Trees,
  // Objects
  Package, Gift, Key, Lock, Wrench,
  Scissors, Lightbulb, Battery, Clock, Calendar,
  Bookmark, Star, Award, Trophy, Target,
  Gem, Crown, Shield, Zap, Flame,
  RefreshCw, Repeat, HelpCircle,
} from 'lucide-react';

export const ICON_COMPONENT_MAP = {
  // People
  'user': User, 'users': Users, 'user-check': UserCheck,
  'user-plus': UserPlus, 'contact': Contact, 'baby': Baby,
  'brain': Brain, 'heart': Heart, 'fingerprint': Fingerprint,
  'hand-heart': HandHeart, 'circle-user-round': CircleUserRound,
  'user-circle': UserCircle,
  // Places
  'building': Building, 'building-2': Building2, 'home': Home,
  'map-pin': MapPin, 'globe': Globe, 'landmark': Landmark,
  'mountain': Mountain, 'map': Map, 'compass': Compass, 'flag': Flag,
  // Business
  'briefcase': Briefcase, 'calculator': Calculator,
  'presentation': Presentation, 'handshake': Handshake,
  'id-card': IdCard, 'receipt': Receipt, 'wallet': Wallet,
  'scale': Scale, 'gavel': Gavel, 'stamp': Stamp,
  // Education
  'graduation-cap': GraduationCap, 'book-open': BookOpen,
  'library': Library, 'school': School, 'notebook': Notebook,
  'pencil': Pencil, 'ruler': Ruler, 'atom': Atom,
  'flask-conical': FlaskConical, 'microscope': Microscope,
  // Health
  'heart-pulse': HeartPulse, 'stethoscope': Stethoscope,
  'pill': Pill, 'syringe': Syringe, 'activity': Activity,
  'dumbbell': Dumbbell, 'apple': Apple, 'bed': Bed,
  'thermometer': Thermometer, 'eye': Eye, 'gauge': Gauge,
  // Tech
  'laptop': Laptop, 'smartphone': Smartphone, 'server': Server,
  'database': Database, 'cpu': Cpu, 'wifi': Wifi,
  'code': Code, 'terminal': Terminal, 'cloud': Cloud,
  'hard-drive': HardDrive, 'monitor': Monitor, 'keyboard': Keyboard,
  'mouse': Mouse, 'printer': Printer, 'cable': Cable,
  'git-branch': GitBranch, 'git-commit-horizontal': GitCommitHorizontal,
  'git-pull-request': GitPullRequest, 'folder-git-2': FolderGit2,
  'folder-tree': FolderTree, 'layers': Layers,
  // Media
  'image': Image, 'camera': Camera, 'video': Video,
  'music': Music, 'mic': Mic, 'film': Film,
  'headphones': Headphones, 'tv': Tv, 'radio': Radio,
  'newspaper': Newspaper, 'play-circle': PlayCircle,
  'sticky-note': StickyNote, 'file-text': FileText,
  // Comms
  'mail': Mail, 'message-circle': MessageCircle, 'phone': Phone,
  'megaphone': Megaphone, 'at-sign': AtSign, 'send': Send,
  'rss': Rss, 'bell': Bell, 'inbox': Inbox,
  'message-square': MessageSquare, 'messages-square': MessagesSquare,
  'link-2': Link2,
  // Finance
  'credit-card': CreditCard, 'banknote': Banknote, 'coins': Coins,
  'piggy-bank': PiggyBank, 'shopping-cart': ShoppingCart,
  'store': Store, 'trending-up': TrendingUp,
  'bar-chart-3': BarChart3, 'pie-chart': PieChart,
  'badge-dollar-sign': BadgeDollarSign,
  'arrow-left-right': ArrowLeftRight, 'bar-chart-2': BarChart2,
  'minus-circle': MinusCircle,
  // Travel
  'car': Car, 'plane': Plane, 'train-front': TrainFront,
  'ship': Ship, 'bike': Bike, 'fuel': Fuel,
  'navigation': Navigation, 'luggage': Luggage,
  'ticket': Ticket, 'route': Route,
  // Nature
  'leaf': Leaf, 'flower': Flower, 'sun': Sun,
  'moon': Moon, 'cloud-sun': CloudSun, 'droplets': Droplets,
  'wind': Wind, 'snowflake': Snowflake, 'sprout': Sprout,
  'trees': Trees,
  // Objects
  'package': Package, 'gift': Gift, 'key': Key,
  'lock': Lock, 'wrench': Wrench, 'scissors': Scissors,
  'lightbulb': Lightbulb, 'battery': Battery, 'clock': Clock,
  'calendar': Calendar, 'bookmark': Bookmark, 'star': Star,
  'award': Award, 'trophy': Trophy, 'target': Target,
  'gem': Gem, 'crown': Crown, 'shield': Shield,
  'zap': Zap, 'flame': Flame,
  'refresh-cw': RefreshCw, 'repeat': Repeat,
  'help-circle': HelpCircle,
};
